import React from 'react';
import { MapPin, Wrench } from 'lucide-react';
import StarField from './StarField';

const AboutSection = () => {
  return (
    <section id="about" className="py-24 bg-black relative overflow-hidden">
      <StarField density="sparse" />
      <div className="container mx-auto px-6 max-w-4xl relative z-10">
        {/* About Me Header */}
        <div className="mb-12">
          <h2 className="text-4xl md:text-5xl font-light text-white mb-4 tracking-tight">
            About Me
          </h2>
          <div className="w-20 h-1 bg-white"></div>
        </div>

        {/* Bio Content */}
        <div className="space-y-6 text-gray-300 leading-relaxed">
          <p className="text-lg font-light">
            I design, build and create primarily mechanical watches. 
            My first build was a MM300 "Night Wing" Mod featuring blue luminous accents 
            on various parts of the build. I also have other watches built such as the 
            "Coffee" Daytona Chronograph Mod featured on my YouTube channel{' '}
            <a 
              href="https://www.youtube.com/@ChillTimeAndWatch" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white font-medium hover:underline"
            >
              @ChillTimeAndWatch
            </a>.
          </p>

          <p className="text-lg font-light">
            I am looking for like-minded individuals who are willing to learn or improve their watch crafting skill. 
            Whether you are a complete beginner, intermediate or advanced at watch building, I hope to discuss designing 
            and crafting unique watches with you all.
          </p>

          <p className="text-lg font-light">
            If you are interested in learning the craft and improving your skills then accept this free 
            membership to join the community watch building/modding Discord server "Chill Time and Watches Workshop"{' '}
            <a 
              href="https://discord.gg/T8yG3KGex4" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white font-medium hover:underline"
            >
              discord.gg/T8yG3KGex4
            </a>
            . Thank you for reading, hope to interact with you all and the community soon.
          </p>
        </div>

        {/* Status Cards */}
        <div className="grid md:grid-cols-2 gap-6 mt-16">
          {/* Availability - clickable to scroll to build service */}
          <button
            onClick={() => {
              const element = document.getElementById('build-service');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="text-left bg-white/5 backdrop-blur-sm border border-white/10 p-8 hover:bg-white/10 hover:border-white/30 hover:shadow-[0_0_40px_rgba(255,255,255,0.15)] hover:-translate-y-1 transition-all duration-300 group text-white cursor-pointer"
          >
            <Wrench className="w-8 h-8 mb-4 group-hover:rotate-12 transition-transform duration-300" />
            <h3 className="text-xl font-medium mb-2">Available for Custom Builds</h3>
            <p className="text-sm font-light opacity-80">I'm currently accepting custom watch build projects</p>
            <p className="text-xs font-light text-white/50 mt-3 group-hover:text-white/80 transition-colors">View Build Service →</p>
          </button>

          {/* Location */}
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 hover:bg-white/10 hover:border-white/30 hover:shadow-[0_0_40px_rgba(255,255,255,0.15)] hover:-translate-y-1 transition-all duration-300 group text-white">
            <MapPin className="w-8 h-8 mb-4 group-hover:scale-110 transition-transform duration-300" />
            <h3 className="text-xl font-medium mb-2">Based in Ontario</h3>
            <p className="text-sm font-light opacity-80">Ontario, Canada</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
